export const getJobsById = (state) => {
  return state.jobs.byId;
};
